import React from 'react';
import styled from 'styled-components';
import GallerySection from '../components/sections/GallerySection';

const GalleryPage = () => {
  return (
    <GalleryPageContainer>
      <GallerySection />
    </GalleryPageContainer>
  );
};

const GalleryPageContainer = styled.div`
  padding-top: 2rem;
`;

export default GalleryPage;